class AccessoryCardGroups extends HTMLElement {
  connectedCallback() {
    this.bindEvents();
    this.syncAllGroups();
  }

  bindEvents() {
    this.addEventListener('change', (evt) => {
      if (!evt.target.matches('[data-accessory-input]')) return;
      this.syncGroup(evt.target.closest('[data-accessory-group]'));
    });

    this.addEventListener('click', (evt) => {
      const qtyWrap = evt.target.closest('[data-accessory-qty-wrap]');
      if (qtyWrap) {
        evt.stopPropagation();
      }

      const qtyBtn = evt.target.closest('.accessory-card__qty-btn, [data-quantity]');
      if (!qtyBtn) return;

      const wrapper = qtyBtn.closest('quantity-wrapper, .accessory-card__qty-wrapper');
      const input = wrapper?.querySelector('[data-accessory-qty]');
      if (!input || input.disabled) return;

      evt.preventDefault();
      evt.stopPropagation();

      let currentValue = parseInt(input.value || '1', 10);
      if (Number.isNaN(currentValue)) currentValue = 1;

      let step = parseInt(input.step || '1', 10);
      if (Number.isNaN(step) || step < 1) step = 1;

      const direction = qtyBtn.dataset.quantity === 'up' ? 1 : -1;
      let newValue = currentValue + direction * step;

      const min = parseInt(input.min || '1', 10);
      if (!Number.isNaN(min)) {
        newValue = Math.max(min, newValue);
      } else {
        newValue = Math.max(1, newValue);
      }

      if (input.max) {
        const max = parseInt(input.max, 10);
        if (!Number.isNaN(max)) {
          newValue = Math.min(max, newValue);
        }
      }

      input.value = newValue;
      input.dispatchEvent(
        new CustomEvent('change', { bubbles: true, cancelable: false })
      );
    });

    this.addEventListener('mousedown', (evt) => {
      if (evt.target.closest('[data-accessory-qty-wrap]')) {
        evt.stopPropagation();
      }
    });
  }

  syncAllGroups() {
    this.querySelectorAll('[data-accessory-group]').forEach((group) => {
      this.syncGroup(group);
    });
  }

  syncGroup(group) {
    if (!group) return;

    const type = group.dataset.inputType;
    const inputs = group.querySelectorAll('[data-accessory-input]');

    inputs.forEach((input) => {
      const card = input.closest('.accessory-card, .slider__item');
      const qtyWrap = card?.querySelector('[data-accessory-qty-wrap]');
      const qtyInput = card?.querySelector('[data-accessory-qty]');

      if (!qtyWrap || !qtyInput) return;

      const isSelected = input.checked && input.dataset.accessoryNone !== 'true';
      qtyWrap.hidden = !isSelected;
      qtyInput.disabled = !isSelected;

      if (!isSelected) qtyInput.value = 1;
    });

    if (type === 'radio') {
      const checked = group.querySelector('[data-accessory-input]:checked');
      if (checked && checked.dataset.accessoryNone === 'true') {
        inputs.forEach((input) => {
          if (input !== checked) {
            const card = input.closest('.accessory-card, .slider__item');
            const qtyWrap = card?.querySelector('[data-accessory-qty-wrap]');
            const qtyInput = card?.querySelector('[data-accessory-qty]');

            if (qtyWrap) qtyWrap.hidden = true;
            if (qtyInput) {
              qtyInput.disabled = true;
              qtyInput.value = 1;
            }
          }
        });
      }
    }
  }
}

if (!customElements.get('accessory-card-groups')) {
  customElements.define('accessory-card-groups', AccessoryCardGroups);
}